module.exports = __webpack_public_path__ + "img/bikes.0a9640de.svg";